import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ProjectInvoice {
  id: string;
  invoice_number: string;
  workbook_id: string;
  stripe_invoice_id: string | null;
  stripe_customer_id: string | null;
  amount_total: number;
  amount_paid: number;
  currency: string;
  status: string;
  hosted_invoice_url: string | null;
  invoice_pdf: string | null;
  invoice_type: string;
  parent_invoice_id: string | null;
  created_by: string;
  created_at: string;
  paid_at: string | null;
}

export const useProjectInvoices = (workbookId: string | undefined) => {
  return useQuery({
    queryKey: ['project-invoices', workbookId],
    queryFn: async () => {
      if (!workbookId) return [];

      const { data, error } = await supabase
        .from('workbook_invoices')
        .select('*')
        .eq('workbook_id', workbookId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching project invoices:', error);
        throw error;
      }

      return data as ProjectInvoice[];
    },
    enabled: !!workbookId,
  });
};